"use client"
import { getFooterMenu, getRGPBanner } from "@/app/utils/request/requestList";
import { useEffect, useState } from 'react';
import { useLanguage } from "../utils/LanguageContext";
// import { useMediaQuery } from "@mui/material";
// import { theme } from "@/app/utils/Common";
import "@/app/style/comm.scss";

type propType = {
  data?: any;
};

const Footer = (props: propType) => {
  const { state: lang } = useLanguage();

  const [footerMenu, setFooterMenu] = useState<any>(null);
  const [footerRGBbanner, setFooterRGBbanner] = useState<any>(null);

  //get CMS Data
  useEffect(() => {
    getFooterMenu({language: lang?.langCode}).then((res) => {
      setFooterMenu(res?.item);
      console.log("footer menu", res);
    });

    getRGPBanner({language: lang?.langCode}).then((res) => {
      setFooterRGBbanner(res?.item?.RGPBanner);
      console.log("RGP banner", res);
    });
  }, [])

  return (
    <footer>
      <div id="seo" className={`fiveCol ${ lang.langCode == "en-us" ? "" : "seo_ch"}`} dangerouslySetInnerHTML={{ __html: footerMenu?.sitemap.value }} >
      </div>
      <div id="footer" className={`${ lang.langCode == "en-us" ? "" : "footer_ch"}`}>
        <span dangerouslySetInnerHTML={{ __html: footerRGBbanner?.rendered }} id="footer-top"></span>
        <div className="nav clearfix" dangerouslySetInnerHTML={{ __html: footerMenu?.bottomlink.value }}>
        </div>
      </div>
    </footer>
  );
};

export default Footer